module.exports = __webpack_public_path__ + "static/media/crnm-back.6987c245.jpg";